var _path, _path2, _circle, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElevator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85417 9.79167C6.85417 8.16933 8.16933 6.85417 9.79167 6.85417H37.2083C38.8307 6.85417 40.1458 8.16933 40.1458 9.79167V33.2917C40.1458 37.0771 37.0771 40.1458 33.2917 40.1458H13.7083C9.92288 40.1458 6.85417 37.0771 6.85417 33.2917V9.79167Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7083 17.625H16.6458H19.5833C20.6649 17.625 21.5417 18.5018 21.5417 19.5833V27.0044C21.5417 28.0859 20.6649 28.9627 19.5833 28.9627H19.2896C19.1814 28.9627 19.0938 29.0504 19.0938 29.1586V34.2708C19.0938 35.3524 18.217 36.2292 17.1354 36.2292H16.1563C15.0747 36.2292 14.1979 35.3524 14.1979 34.2708V29.1586C14.1979 29.0504 14.1102 28.9627 14.0021 28.9627H13.7083C12.6268 28.9627 11.75 28.0859 11.75 27.0044V19.5833C11.75 18.5018 12.6268 17.625 13.7083 17.625Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.646,
    cy: 12.7291,
    r: 1.95833,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8247 14.5896C31.0508 14.1979 31.6162 14.1979 31.8423 14.5896L34.2166 18.7021C34.4428 19.0937 34.1601 19.5833 33.7078 19.5833H28.9591C28.5069 19.5833 28.2242 19.0938 28.4504 18.7021L30.8247 14.5896Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8247 32.4104C31.0508 32.8021 31.6162 32.8021 31.8423 32.4104L34.2166 28.2979C34.4428 27.9063 34.1601 27.4167 33.7078 27.4167H28.9591C28.5069 27.4167 28.2242 27.9062 28.4504 28.2979L30.8247 32.4104Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevator);
export default __webpack_public_path__ + "static/media/Elevator.cb6d04ea515811077365ac4b661bd90f.svg";
export { ForwardRef as ReactComponent };